import { useContext } from "react";
import { AppContext } from "../App";
import {
  MdApartment,
  MdArrowForward,
  MdCheckCircle,
  MdGppGood,
  MdGroups,
  MdOutlineBadge,
} from "react-icons/md";
import { companyInfo, principles, regions, strengths } from "./RunzeweContent";

export default function AboutUsContent() {
  const appContext = useContext(AppContext);

  return (
    <>
      <section className="page-hero about-page-hero">
        <div className="page-hero-overlay" />
        <div className="container page-hero-content" data-aos="fade-up">
          <p className="section-kicker">Company Overview</p>
          <h1>Trusted Security Solutions Across Tanzania</h1>
          <p>
            A licensed, Tanzanian-owned security company serving people,
            property, facilities, and critical operations with discipline and
            integrity.
          </p>
        </div>
      </section>

      <section className="content-section">
        <div className="container">
          <div className="split-grid">
            <div data-aos="fade-right">
              <p className="section-kicker">Who We Are</p>
              <h2>Built for reliable protection since 2019.</h2>
              <p>
                {companyInfo.fullName} was established in {companyInfo.established}
                to provide high-quality, customized security solutions. The
                company is incorporated in Tanzania and permitted by the Office
                of the Inspector General of Police to operate private security
                services in approved regions.
              </p>
              <p>
                Runzewe combines trained guards, field supervision, intelligence
                awareness, and technical systems including CCTV and access
                control to deliver protection that matches each client's
                operational environment.
              </p>

              <button className="btn-runzewe btn-runzewe-primary" onClick={() => appContext.navTo({ item: "about", subItem: "team" })}>
                <span>Meet the Team</span>
                <MdArrowForward />
              </button>
            </div>

            <div className="overview-card-grid">
              {strengths.map((item, index) => {
                const icons = [<MdGppGood />, <MdGroups />, <MdCheckCircle />, <MdOutlineBadge />];

                return (
                  <div className="overview-card" key={item.title} data-aos="zoom-in" data-aos-delay={index * 70}>
                    <div>{icons[index]}</div>
                    <h3>{item.title}</h3>
                    <p>{item.description}</p>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </section>

      <section className="content-section section-soft">
        <div className="container">
          <div className="section-heading" data-aos="fade-up">
            <p className="section-kicker">Vision, Mission & Values</p>
            <h2>The standards behind every assignment.</h2>
          </div>

          <div className="values-grid">
            {principles.map((item, index) => (
              <div className="value-card" key={item.title} data-aos="fade-up" data-aos-delay={index * 80}>
                <MdCheckCircle />
                <h3>{item.title}</h3>
                <p>{item.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="content-section">
        <div className="container">
          <div className="split-grid split-grid-reverse">
            <div className="image-panel" data-aos="fade-right">
              <img src={companyInfo.gateImage} alt="Runzewe security at a protected premises" />
            </div>

            <div data-aos="fade-left">
              <p className="section-kicker">Licensing & Coverage</p>
              <h2>Permitted, compliant, and ready to scale.</h2>
              <p>
                Runzewe Security operates from its Geita headquarters with
                branch coverage and approved operating regions across the
                country, including Dar es Salaam, Pwani, Dodoma, Mwanza, Kagera,
                Kigoma, Singida, Shinyanga, Tabora, and Zanzibar.
              </p>

              <div className="region-list">
                {regions.map((region, index) => (
                  <span key={region} data-aos="fade-up" data-aos-delay={(index % 4) * 60}>
                    <MdApartment />
                    {region}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
